import Modal from '@ui/Modal/component'

export default function (footerEl: HTMLElement): void {
  const modalEl = document.getElementById('footer-newsletter-modal')
  if (!modalEl) {
    return
  }

  const inputEmail = document.getElementById('newsletterInputEmail') as HTMLInputElement
  const modal = Modal(modalEl)

  footerEl.querySelector('.footer-newsletter button[type="submit"]')?.addEventListener('click', (e) => {
    e.preventDefault()
    const iframe = document.getElementById('newsletter-iframe') as HTMLIFrameElement

    if (iframe && !iframe.hasAttribute('src')) {
      const params = inputEmail.value ? `?email=${encodeURI(inputEmail.value)}` : ''
      iframe.src = iframe.getAttribute('data-src') + params
    }

    modal.open()
  })
}
